"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = void 0;

var _styles = require("@material-ui/core/styles");

var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: {
      height: '100vh',
      display: 'flex',
      flexDirection: 'column'
    },
    toolbar: theme.mixins.toolbar,
    content: {
      height: '100%',
      flexGrow: 1,
      display: 'flex',
      flexDirection: 'column'
    },
    splashContainer: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexGrow: 1
    },
    splash: {
      maxWidth: '60%',
      maxHeight: '100%'
    }
  };
});
exports.useStyles = useStyles;